import { useSyncExternalStore } from 'react';

/**
 * KAN-1186 - open/close request for the Security alerts pop-up.
 *
 * The pill (`SecurityEventsHeroMark`) lives in the dashboard's filter row and only ASKS; the pop-up
 * (`SecurityEventsHost`) is mounted at home level, so a tab change behind it never unmounts it and
 * its exit still plays. Module-level (no provider); holds one boolean, no tenant data.
 */
let open = false;
const listeners = new Set();
const set = (v) => { if (open !== v) { open = v; listeners.forEach((l) => l()); } };

export const openSecurityEventsModal = () => set(true);
export const closeSecurityEventsModal = () => set(false);
export const resetSecurityEventsModal = () => set(false);
export const isSecurityEventsModalOpen = () => open;
const subscribe = (l) => { listeners.add(l); return () => { listeners.delete(l); }; };
export const useSecurityEventsModalOpen = () => useSyncExternalStore(subscribe, () => open, () => false);
